import { render, staticRenderFns } from "./notification-pending-rates.view.vue?vue&type=template&id=98b1de70&"
import script from "./notification-pending-rates.view.vue?vue&type=script&lang=js&"
export * from "./notification-pending-rates.view.vue?vue&type=script&lang=js&"
import style0 from "./notification-pending-rates.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VSubheader})
